import {
	HealthBookingEnum,
	TelehealthBookingEnum,
	OdontoBookingEnum,
	ExamBookingEnum,
} from 'presentation/constants';
import {BookingTypeEnum} from './bookingTypeEnum';

export const CONFIRMATION_PATH = {
	[BookingTypeEnum.HEALTH]: HealthBookingEnum.HEALTH_BOOKING_CONFIRMATION,
	[BookingTypeEnum.TELEHEALTH]: TelehealthBookingEnum.TELEHEALTH_BOOKING_CONFIRMATION,
	[BookingTypeEnum.ODONTO]: OdontoBookingEnum.ODONTO_BOOKING_CONFIRMATION,
	[BookingTypeEnum.EXAM]: ExamBookingEnum.EXAM_BOOKING_CONFIRMATION,
};
